import { ethers as e } from "ethers";
import { MatchingMarketContractAbi as n } from "@deorderbook/contracts/abi";
import { MatchingMarketAddress as o } from "@deorderbook/contracts";
import { signer as c, provider as a } from "./provider.mjs";
const i = () => new e.Contract(
  o,
  n
), f = (r = !1) => {
  const t = i();
  return r ? t.connect(c) : t.connect(a);
};
export {
  i as initMarketBulletContract,
  f as useMarketBulletContract
};
//# sourceMappingURL=marketBulletContract.mjs.map
